<template>

  <div class="viewer-3d">
   
    <a-scene  shadow="type: basic; autoUpdate: false;" 
              vr-mode-ui="enabled: true">

        

              <a-entity animation-mixer="duration: 48" 
                        id="mbell" 
                        gltf-model="/assets/bell4.glb"
                        scale="1 1 1" 
                        position="0 1 1.5" 
                        visible="true" 
                        shadow="cast: false"
                        animation="property: rotation; from: 0 0 0; to: 360 720 0 ; dur:75000; loop: true;"
              ></a-entity>




            <!-- Lights -->
            <a-entity light="intensity: 1.0; castShadow: false; shadowBias: -0.001; shadowCameraFar: 501.02; shadowCameraBottom: 12; shadowCameraFov: 101.79; shadowCameraNear: 0; shadowCameraTop: -5; shadowCameraRight: 10; shadowCameraLeft: -10; shadowRadius: 2" position="1.36586 7.17965 1"></a-entity>
            <a-entity light="type: ambient; intensity: 1.0"></a-entity>
            
            <a-entity rotation="90 0 0"
                      animation="property:position; from: 0 0.75 0; to: 0 1.5 0; dur:90000; dir: alternate; loop: true; easing:easeInElastic;"

            >
                
                <!-- <a-light type="point" color="white" intensity=".15"></a-light> -->

                <a-camera fov="100" 
                wasd-controls-enabled="false"
                look-controls-enabled="false"
                 animation="property:fov; from:100; to:175; dur:100000; dir: alternate; loop: true; easing:easeInElastic"
                 ></a-camera>

            </a-entity>  
            
            <!-- Sky -->
            <a-sky color="#000"></a-sky>


    </a-scene>

  </div>


</template>

<script>

import {mapGetters} from "vuex";
import AFRAME from 'aframe';
require('aframe-extras');

import AframeOrbitControls from 'aframe-orbit-controls';

export default {
  name: 'Viewer3d',
  created() {

    // this.$store.dispatch('Model3d/setModel', process.env.VUE_APP_BASE_URL+'/assets/tavolo.glb');

    // Object.keys(this.filters).forEach((key) => {
    //     this.filters[key].model = this.filters[key].options[0].value; //Object.assign(this.filters[key].model, this.filters[key].options[0])
        
    //     setTimeout(() => {
    //       this.changeMaterial(this.filters[key].target, this.filters[key].options[0].value);

    //       this.showModel = true;
    //     },2500)
        
    // });
    
    console.log("3D Viewer");

  },
  data() {
    return {

      showModel : false,



    }
  },


  methods: {



  },

  computed: {

      ...mapGetters({

          //model: 'Model3d/model',

      }),
  }


}
        

</script>

<style lang="scss" scoped>
  .cols {
    display: flex;
    justify-content: center;

    &>* {
      padding: .5rem;
    }
    .filters {

      flex:1;
      text-align: left;

    }


  }
    #d3 {

      width: 100%;
      height: 75vh;

    }

</style>